import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import {
  MatAutocomplete,
  MatAutocompleteTrigger,
} from '@angular/material/autocomplete';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  IELAsyncAutocompleteElement,
  SELECTION_MODE,
} from '@el-async-autocomplete';
import { TranslateService } from '@ngx-translate/core';

import { IAssign } from '@shared/interfaces';

import { IdentitiesService } from '../../../identities/services/identities.service';

@Component({
  selector: 'app-return-popup',
  templateUrl: './return-popup.component.html',
  styleUrls: ['./return-popup.component.scss'],
})
export class ReturnAssetComponent implements OnInit {
  @ViewChild('auto', { static: false }) matAutocomplete: MatAutocomplete;
  autoComplete: MatAutocompleteTrigger;
  SELECTION_MODE = SELECTION_MODE;

  constructor(
    public dialogRef: MatDialogRef<ReturnAssetComponent>,
    @Inject(MAT_DIALOG_DATA) protected data,
    public translate: TranslateService,
    private identitiesService: IdentitiesService
  ) {}

  ReturnAssetForm: FormGroup<{
    return_on_date: FormControl<Date>;
    remarks: FormControl<string>;
  }>;

  assignee: IELAsyncAutocompleteElement[] = [];
  filteredInvitees: any;
  selectedUsers: IELAsyncAutocompleteElement;
  isAssignee = false;
  selectable = true;
  isView = false;
  isUpdate = false;
  loggedUserData: any;
  minDate = new Date(
    this.data.assign_asset[this.data.assign_asset.length - 1].lend_on_date
  );

  ngOnInit(): void {
    this.setFormData();
    this.ReturnAssetForm.get('return_on_date');
    this.ReturnAssetForm.get('remarks').setValue('');
  }
  setFormData() {
    this.ReturnAssetForm = new FormGroup({
      return_on_date: new FormControl(null),
      remarks: new FormControl(null),
    });
  }

  onReturn(): void {
    if (this.ReturnAssetForm.invalid) return;
    if (this.ReturnAssetForm.valid) {
      const project: IAssign = {
        ...this.data,
        return_on_date: this.ReturnAssetForm.get('return_on_date').value,
        remarks: this.ReturnAssetForm.get('remarks').value,
      };

      this.dialogRef.close(project);
    }
  }

  onClose(): void {
    this.dialogRef?.close?.();
  }
}
